// extracted by mini-css-extract-plugin
export default {"head":"billPayment_head__KHrac","quick":"billPayment_quick__klmid","q":"billPayment_q__5fm4r","due":"billPayment_due__yuBsx","dueClear":"billPayment_dueClear__D-Ui1"};